/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveOrRejectProjectItemSubmittalCommand } from '../../models/approve-or-reject-project-item-submittal-command';
import { ApproveOrRejectProjectItemSubmittalCommandResult } from '../../models/approve-or-reject-project-item-submittal-command-result';

export interface ApiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Params {
  
    /**
     * The command to approve or reject a project item submittal.
     */
    body?: ApproveOrRejectProjectItemSubmittalCommand
}

export function apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch(http: HttpClient, rootUrl: string, params?: ApiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveOrRejectProjectItemSubmittalCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApproveOrRejectProjectItemSubmittalCommandResult>;
    })
  );
}

apiProjectItemSubmittalsConsultantApproveOrRejectProjectItemSubmittalPatch.PATH = '/api/ProjectItemSubmittals/ConsultantApproveOrRejectProjectItemSubmittal';
